/**
 * 应用入口（T01 接管 T04 的开发入口）。
 *
 * 挂载顺序：设计令牌 → 全局基线样式 → 手机竖屏外壳 + 哈希路由。
 * T04 的清单演示页 `ManifestDemo` 仍保留在 `src/ui/`，`npm run manifest` 不受影响。
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './design/tokens.css';
import './app/global.css';
import { App } from './app/App';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('找不到挂载节点 #root，请检查 index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);